import Vue from 'vue'
import Vuex from 'vuex'
import {axios, Toast} from "./tools";
import {host} from "./config";
import language from  './tools/language'
import localStore from './tools/localstorage'
// 引入vuex持久化插件
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

let state = {
  USDTDec: 18,
  accounts: [],
  //登录信息，必须初始化
  token: '',
  uid: '',
  mobile: '',
  nickname: '',
  // 0 中文 1繁体 2 英文
  languagetype: 2,
  language: language,
  showChuanTong: false,
  showNotice: false,
  getInvite: false,
  getInvite1: 0,
  messages: [
    {"role": "user", "content": "hello"},
    {"role": "assistant", "content": "Hello! How can I assist you today?"},
  ],
  funds: 0,
};
if(!localStore.fetch('messages')){
  localStore.save('messages',state.messages)
}

const mutations = {
  /*
  * 设置state
  * */
  setState(state, params) {
    for (let k in params){
      state[k] = params[k]
    }
  }
};

/* 获取所有配置 */
const actions = {
  async initData() {
  },
  setGlobalConfig(){
    axios({
      method: 'post',
      url: host + 'user/config',
      data: {
        uid: state.uid || window.localStorage.getItem('uid'),
      },
    }).then(function (response) {
      if (response.data && response.data.code === 0) {
        const list = response.data.data.list;
        for (let k in list) {
          state.globalConfig[list[k].configKey] = list[k].configValue;
        }
      }
    }).catch(() => {
      Toast('全局配置请求失败')
    });
  },
  getDownloadUrl(){
    axios({
      method: 'post',
      url: host + 'user/download',
    }).then(function (response) {
      if (response.data && response.data.code === 0) {
        state.downloadUrl = response.data.data;
      }
    }).catch(() => {
      Toast('全局配置请求失败')
    });
  },
  /*
  * 拿个人信息
  * */
  getUserInfo(){
    return axios({
      method: 'post',
      url: host + 'user/query_info',
      data: {
        uid: state.uid,
      },
    }).then(function (response) {
      if (response.data && response.data.code === 0) {
        state.nickname = response.data.data.nickname;
        window.localStorage.setItem('nickname', state.nickname);
      }
    });
  }

};
// const plugins = [
//   createPersistedState({
//     // 存储方式：localStorage、sessionStorage、cookies
//     storage: window.sessionStorage,
//     // 存储的 key 的key值
//     key: 'store',
//     render (state) {
//       // 要存储的数据：本项目采用es6扩展运算符的方式存储了state中所有的数据
//       return { ...state }
//     }
//   })
// ]
export default new Vuex.Store({
  state,
  mutations,
  actions,
  // plugins
})
